import { apiAxios } from '../../../helpers'
import vuetifyToast from 'vuetify-toast'

export const setCreate = async (stadium) => {
  const result = await apiAxios.post('stadiums/create', stadium)
  vuetifyToast.show({
    text: result.data.message.reason,
    color: 'success',
    timeout: 2000,
    icon: 'warning'
  })
}

export const setUpdate = async (stadium) => {
  const result = await apiAxios.put('stadiums/' + stadium._id, stadium)
  vuetifyToast.show({
    text: result.data.message.reason,
    color: 'success',
    timeout: 2000,
    icon: 'warning'
  })
}

export const setDelete = async (id) => {
  const result = await apiAxios.delete('stadiums/' + id)
  vuetifyToast.show({
    text: result.data.message.reason,
    color: 'success',
    timeout: 2000,
    icon: 'warning'
  })
}
